<script>
export default {
    name: "AdmissionNotePrint",

    data() {

        return {
            admissionReport: {},
        };
    },

    mounted() {

        this.$root.loading=true;
        Promise.allSettled([ this.fetchAdmissionNote(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchAdmissionNote() {
            let url = `Morgue/GetMorgueAdmssionSheet`;
                url += `?AdmissionID=${this.$route.query.AdmissionID}`;

            return this.$http.get(url).then(response => {
                const admissionReport = response.data;
                this.admissionReport = admissionReport.length ? admissionReport[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-2">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center p-1 my-1 mt-3">
            <h5 class="text-base font-medium uppercase"> 
                <span class="text-blue-800">{{ admissionReport.patient }}</span></h5>
        </div>
      
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base uppercase">Name: {{ admissionReport.patient}}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base uppercase">MRN: {{ admissionReport.patienT_ID }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Morque No: {{ admissionReport.morgueNo }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">National Id: {{ admissionReport.nationalid }}</h5>
            </div>
             
        </div> 
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Date Admitted: {{ admissionReport.date | dateFormat }}</h5>
            </div>
            
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Package: {{ admissionReport.package }}</h5>
            </div>
             
        </div>
         
         <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Brought By: {{ admissionReport.broughtBy|'-'}}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Brought By Relationship: {{ admissionReport.broughtByRelationship|'-' }}</h5>
            </div> <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Brought By ID: {{ admissionReport.broughtByIdNo|'-' }}</h5>
            </div>
            
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Brought By Tel: {{ admissionReport.broughtByTelNo|'-' }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Village: {{ admissionReport.village|'-' }}</h5>
            </div>
            
            
        </div> <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Place of Death: {{ admissionReport.placeOfDeath|'-' }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Chief: {{ admissionReport.chief|'-' }}</h5>
            </div>
            
            
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Admiited By: {{ admissionReport.admittedBy|'-' }}</h5>
            </div><div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">User: {{ admissionReport.userName|'-' }}</h5>
            </div>
               
        </div>
    </div>
</template>